import { render } from "./ToggleBtn.vue?vue&type=template&id=5b6e0688&scoped=true"
import script from "./ToggleBtn.vue?vue&type=script&lang=js"
export * from "./ToggleBtn.vue?vue&type=script&lang=js"

import "./ToggleBtn.vue?vue&type=style&index=0&id=5b6e0688&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6e0688"]])

export default __exports__